var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal-rental","hide-header":"","hide-footer":"","centered":""}},[_c('div',{staticClass:"my-4 text-center"},[_c('p',[_vm._v(" ระบบไม่พบข้อมูลผู้แทนจำหน่าย "),_c('br'),_vm._v(" โปรดติดต่อ โทร xxxxxx ")]),_c('b-button',{staticClass:"btn btn-submit",on:{"click":_vm.closeModal}},[_vm._v("ตกลง")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }